import React from "react";
import { Link, useSearchParams } from "react-router-dom";

/** Port of ValidityWarning.php */
export function ValidityWarning() {
  const [q] = useSearchParams();
  let days = "";
  try { days = atob(q.get("Q") || ""); } catch { days = ""; }
  return (
    <div className="my-5 pt-5" data-testid="validity-warning-page">
      <div className="container">
        <div className="row"><div className="col-lg-12">
          <div className="text-center my-5">
            <h3 className="text-uppercase">Service Will be  Expire With In <span className="error-text" data-testid="validity-days"> {days} Days</span>  Please Clear ReNew.</h3>
            <div className="mt-5 text-center">
              <Link className="btn btn-primary waves-effect waves-light" to="/" data-testid="validity-continue-button">Continue</Link>
            </div>
          </div>
        </div></div>
      </div>
    </div>
  );
}

/** Port of includes/Validate.php (licence expired gate — purchase-code entry is not implemented in legacy beyond the heading) */
export function ValidityExpired() {
  return (
    <div className="my-5 pt-5" data-testid="validity-expired-page">
      <div className="container"><div className="text-center my-5">
        <h3 className="text-uppercase">Please Enter Purchase Code</h3>
        <p className="text-muted mt-3">Your service validity has expired. Please contact the provider to renew.</p>
        <Link className="btn btn-primary mt-3" to="/auth-login" data-testid="validity-back-login">Back to Login</Link>
      </div></div>
    </div>
  );
}
